if (!Element.prototype.replaceChildren) {
    Element.prototype.replaceChildren = function() {
        this.innerHTML = '';
        for (let i = 0; i < arguments.length; i++) {
            const child = arguments[i];
            this.appendChild(child instanceof Node ? child : document.createTextNode(String(child)));
        }
    }
}
